export default "__VITE_ASSET__FLKX0Hso__"